import React from 'react';

import { CartLayout } from '@sharedComponents/Layout';
import { ReactFCV } from '@types';
import { CypressTestNamespace } from '@utils/test';

import { BodyColumn, InfoColumn, PriceColumn } from './componentHelpers';

export interface IDiscountItemProps {
  text: string | React.ReactNode;
  description?: string;
  value?: number;
  isDualPriceLayout: boolean;
}

export const DiscountItem: ReactFCV<IDiscountItemProps> = ({ text, description, value = 0, isDualPriceLayout }) => (
  <CartLayout
    className={CypressTestNamespace.ECartPageDiscounts.DISCOUNT_CODE_LIST_ITEM}
    serviceActive={true}
    serviceDisabled={false}
    bodyColumn={BodyColumn(text)}
    infoColumn={description ? InfoColumn(description) : null}
    priceColumn={PriceColumn(isDualPriceLayout, value)}
  />
);
